import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ExportKind = "list" | "progressReport" | "missionList";
export type TicketExportStatus = "idle" | "pending" | "processing" | "uploading" | "completed" | "failed";

export interface SingleExportState {
  status: TicketExportStatus;
  exportId: number | null;
  startedAt: number | null;
  error: string | null;
}

export interface TicketExportState {
  list: SingleExportState;
  progressReport: SingleExportState;
  missionList: SingleExportState;
}

function initialSingleExportState(): SingleExportState {
  return { status: "idle", exportId: null, startedAt: null, error: null };
}

const initialState: TicketExportState = {
  list: initialSingleExportState(),
  progressReport: initialSingleExportState(),
  missionList: initialSingleExportState(),
};

const ticketExportSlice = createSlice({
  name: "ticketExport",
  initialState,
  reducers: {
    exportRequested(state, action: PayloadAction<{ kind: ExportKind }>) {
      state[action.payload.kind] = { status: "pending", exportId: null, startedAt: null, error: null };
    },
    exportCreated(state, action: PayloadAction<{ kind: ExportKind; exportId: number; startedAt: number }>) {
      state[action.payload.kind].exportId = action.payload.exportId;
      state[action.payload.kind].startedAt = action.payload.startedAt;
    },
    exportResumed(state, action: PayloadAction<{ kind: ExportKind; exportId: number; startedAt: number }>) {
      state[action.payload.kind].exportId = action.payload.exportId;
      state[action.payload.kind].startedAt = action.payload.startedAt;
      state[action.payload.kind].status = "processing";
      state[action.payload.kind].error = null;
    },
    exportStatusUpdated(
      state,
      action: PayloadAction<{ kind: ExportKind; status: TicketExportStatus; error?: string | null }>
    ) {
      state[action.payload.kind].status = action.payload.status;
      state[action.payload.kind].error = action.payload.error ?? null;
    },
  },
});

export const { exportRequested, exportCreated, exportResumed, exportStatusUpdated } = ticketExportSlice.actions;
export default ticketExportSlice.reducer;
